import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-select-two-lines-container , xpoSelectTwoLinesContainer',
  host: {
    class: 'xpo-Select-twoLinesContainer',
  },
})
export class XpoSelectTwoLinesContainer {}
